import get from 'lodash/get';
import setWith from 'lodash/setWith';

const FEATURE_NAMES = Object.freeze({
  SHARED_OPTIONS: 'SHARED_OPTIONS',
});

const { SHARED_OPTIONS } = FEATURE_NAMES;

const getFeaturesByCompanyMap = (rawFeaturesData = []) => {
  const featuresMap = {};
  rawFeaturesData.forEach((feature) => {
    const companyId = get(feature, 'company.id');
    const { enabled, feature: featureName } = feature;
    setWith(featuresMap, `${featureName}[${companyId}]`, enabled, Object);
  });
  return featuresMap;
};

const getOneFeaturesRequestArgs = (apiToken, id) => ({ apiToken, path: ['companies', id, 'features'] });

const getCompanyFeaturesRequests = (firstApiToken, company, multiAccountCompanies) => {
  let requestArgs = [];
  requestArgs.push(getOneFeaturesRequestArgs(firstApiToken, company.id));
  multiAccountCompanies.forEach((adminCompany) => {
    const companyId = get(adminCompany, 'company.id');
    const apiToken = get(adminCompany, 'apiToken');
    requestArgs.push(getOneFeaturesRequestArgs(apiToken, companyId));
  });
  requestArgs = requestArgs.filter(path => !!path);
  return requestArgs;
};

const isFeatureEnabled = (admin, featureName) => {
  const featuresMap = get(admin, 'features');
  const companyId = get(admin, 'company.id');
  return get(featuresMap, `${featureName}[${companyId}]`);
};

const isSharedOptionsEnabled = admin => isFeatureEnabled(admin, SHARED_OPTIONS);

export {
  getCompanyFeaturesRequests,
  getFeaturesByCompanyMap,
  isFeatureEnabled,
  isSharedOptionsEnabled,
  SHARED_OPTIONS,
};
